var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50002 12.5003L12.5 7.50029M9.16669 5.0003L9.55252 4.55363C10.334 3.77223 11.3939 3.3333 12.4991 3.33337C13.6042 3.33345 14.664 3.77254 15.4454 4.55405C16.2268 5.33555 16.6658 6.39545 16.6657 7.50059C16.6656 8.60573 16.2265 9.66557 15.445 10.447L15 10.8336M10.8334 15.0003L10.5025 15.4453C9.71191 16.2271 8.64486 16.6656 7.53295 16.6656C6.42105 16.6656 5.354 16.2271 4.56337 15.4453C4.17367 15.06 3.86428 14.6011 3.65313 14.0954C3.44198 13.5897 3.33325 13.0471 3.33325 12.499C3.33325 11.951 3.44198 11.4084 3.65313 10.9027C3.86428 10.3969 4.17367 9.93813 4.56337 9.5528L5.00004 9.16696",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.dbdd464d64953c0166e8456e25a36d3a.svg";
export { ForwardRef as ReactComponent };